// @ts-nocheck
import { Dictionary } from "@insite/client-framework/Common/Types";
import getBooleanProperty from "@toolkit/Framework/Common/Utilities/getBooleanProperty";

/**
 * Filters out lines that are marked as not in catalog.
 *
 * @template T - An array type that extends an object with a `properties` dictionary, or null/undefined.
 * @param lines - The array of lines to filter, where each line contains a `properties` object with catalog status.
 * @returns The filtered array of the same type as input, excluding lines where `notInCatalog` evaluates to true.
 *          Returns the input unchanged if it is null or undefined.
 *
 * @example
 * const filteredLines = removeNotInCatalogLines(lines);
 */
const removeNotInCatalogLines = <T extends { properties: Dictionary<string> }[] | null | undefined>(lines: T) => {
    if (!lines) {
        return lines;
    }

    return lines.filter(x =>
        typeof x.properties?.notInCatalog === "string" ? !getBooleanProperty(x.properties.notInCatalog) : true,
    ) as T;
};

export default removeNotInCatalogLines;
